<template>
	<value-container v-if="view_only" :value="text" :label="label" :md="md"/>
	<component v-else :is='c_tag' :md4="md==4" :md5="md==5" :md8="md==8" :md12="md==12">
		<fs1-span><b>{{label || ''}}</b></fs1-span>
		<slot></slot>
		<v-textarea
			:rows="rows||null"
			:class="text != null ? '': (optional?'':'textEmpty')"
			:placeholder="c_placeholder"
			:value="text"
			:disabled="disabled"
			v-on:input="updateInput"/>
			<value-container v-if="old_value !== undefined" :value="old_value" class_name="output_old_value_edit"/>
	</component>
</template>

<script>
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  model: { prop: "text", event: "input" },
	props: ['text','view_only','rows'],
  methods: { updateInput(v) { this.$emit('input', v) } }
};
</script>
